import SyntaxHighlighter from 'react-syntax-highlighter';
import styled from 'styled-components';

import { customScrollMinimal } from '~/components/custom-scroll/CustomScroll.styles';

export const StyledSyntaxHighlighter = styled(SyntaxHighlighter)`
  ${customScrollMinimal};
`;
